module.exports = __webpack_public_path__ + "img/脑血管功能.2794d59c.png";